/**
 * @generated SignedSource<<f6730fa61411a50b18c632b24436ca49>>
 * @relayHash f78ccda1f54d3fcb8894d76abca28091
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf5c390ebb42a8df3f27c63920dca9fd3585cd581db98c7196847bbd81ea2782

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ProductsJsmWorkforceSkillsPageSiteWfoStatusQuery } from './ProductsJsmWorkforceSkillsPageSiteWfoStatusQuery.graphql';

const node: PreloadableConcreteRequest<ProductsJsmWorkforceSkillsPageSiteWfoStatusQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cf5c390ebb42a8df3f27c63920dca9fd3585cd581db98c7196847bbd81ea2782",
    "metadata": {},
    "name": "ProductsJsmWorkforceSkillsPageSiteWfoStatusQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
